import React from 'react';
import './Footer.css';
import { Link, useLocation } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { useEffect } from 'react';

const Footer = () => {
  const location = useLocation();

  // Scroll to top when Home is clicked
  useEffect(() => {
    if (location.pathname === "/") {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Company Info Section */}
        <div className="footer-section company-info">
          <h2 className="company-logo">DATA <span>BOLTA HAI</span></h2>
          <p>
            Our Goal Is To Help Our Companies Maintain Achieve Best Class Positions 
            In Their Respective Industries & Our Team Works Occur That Works Have To Be Repudiated.
          </p>
          <div className="social-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaLinkedinIn /></a>
            <a href="https://www.youtube.com/@databoltahi6388" target="_blank" rel="noopener noreferrer">
            <FaYoutube />
            </a>
          </div>
        </div>

        {/* Services Section */}
        <div className="footer-section">
          <h3>Our Services</h3>
          <ul>
            <li><Link to="/big-data-solution" onClick={() => window.scrollTo(0, 0)}>Big Data Solution</Link></li>
            <li><Link to="/bank-data-solution" onClick={() => window.scrollTo(0, 0)}>Bank Data Solution</Link></li>
            <li><Link to="/gst-reconciliation" onClick={() => window.scrollTo(0, 0)}>GST Reconciliation</Link></li>
            <li><Link to="/cyber-forensic" onClick={() => window.scrollTo(0, 0)}>Cyber Forensic</Link></li>
            <li><Link to="/call-analytics" onClick={() => window.scrollTo(0, 0)}>Call Analytics</Link></li>
            <li><Link to="/cyber-security" onClick={() => window.scrollTo(0, 0)}>Cyber Security</Link></li>
            <li><Link to="/digital-marke" onClick={() => window.scrollTo(0, 0)}>Digital Marketing</Link></li>
          </ul>
        </div>

        {/* Links Section */}
        <div className="footer-section">
          <h3>Our Links</h3>
          <ul>
            <li>
              <Link to="/" onClick={() => window.scrollTo(0, 0)}>Home</Link>
            </li>
            <li>
              <Link to="/about#mission-section">Vision and Mission</Link>
            </li>
            <li>
              <Link to="/about#team-section">Our Team</Link>
            </li>
            <li>Blog</li>
            <li>
              <Link to="/contact-us" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-section contact-info">
          <h3>Contact Us</h3>
          <p><FaMapMarkerAlt /> B 301 New Gokul Heights CHSL, Kandivali East, Mumbai</p>
          <p><FaPhoneAlt /> +91 70215-20017</p>
          <p><FaEnvelope /> info@databoltahi.com</p>
        </div>
      </div>
    
      {/* Copyright */}
      <div className="footer-bottom">
        <p>Copyright ©2025 <span>Data Bolta Hai</span></p>
      </div>
    </footer>
  );
};

export default Footer;



